export enum CampaignStateDefinition {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Draft = 'Draft',
  Finished = 'Finished',
  Ready = 'Ready',
  Recalled = 'Recalled',
  Recalling = 'Recalling',
  Recurring = 'Recurring',
  Running = 'Running',
  Scheduled = 'Scheduled',
}

export enum CampaignTypeDefinitions {
  ApiTriggered = 'ApiTriggered',
  Blast = 'Blast',
  WithAI = 'WithAI',
  WithExperiment = 'WithExperiment',
  WorkflowTriggered = 'WorkflowTriggered',
}
